import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import XLSX from 'xlsx'
import {Table, Button} from 'semantic-ui-react'

class MovementTable extends Component {
    dataToExcel = () => {
        const fn = 'movement.xlsx';
        let elt = document.getElementById('dls-data-table');
        let wb = XLSX.utils.table_to_book(elt, {sheet: "Inventory"});
        return XLSX.writeFile(wb, fn);
    }

    getWarehouse = ({shipment}) => {
        if (!shipment) {
            return "NA";
        }
        const {warehouse_id} = shipment;
        const {warehouses} = this.props;
        const wh = warehouses.filter(w => {
            return parseInt(w.value) === parseInt(warehouse_id);
        });
        if (wh.length > 0) {
            return wh[0].text;
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12" style={{marginBottom: '3px'}}>
                    <div style={{float:'right'}}>
                        <Button color='purple' size='mini' onClick={() => {this.dataToExcel()}}>Excel</Button>
                    </div>
                </div>
                <div className="col-md-12"  style={{maxHeight: '575px', overflowY: 'scroll', height: '575px', alignContent:'top'}}>
                <Table compact celled id='dls-data-table'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>SKU</Table.HeaderCell>
                            <Table.HeaderCell>Transaction Date</Table.HeaderCell>
                            <Table.HeaderCell>Transaction Type</Table.HeaderCell>
                            <Table.HeaderCell>QB Ref</Table.HeaderCell>
                            <Table.HeaderCell>Order Ref</Table.HeaderCell>
                            <Table.HeaderCell>Customer / Vendor</Table.HeaderCell>
                            <Table.HeaderCell>Warehouse</Table.HeaderCell>
                            <Table.HeaderCell>Quantity</Table.HeaderCell>
                            <Table.HeaderCell>Price</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.data.map(i => {
                            return i.shipment_lines.map(s => {
                                return (
                                    <Table.Row key={s.id}>
                                        <Table.Cell>{i.sku}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.invoice_date : ""}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.acct_type === 'None' ? 'Adjustment' : s.shipment.acct_type : ""}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.invoice_number : ""}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.order ? s.shipment.order.so : "" : ""}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.relation_name ? s.shipment.relation_name.company_name : "" : ""}</Table.Cell>
                                        <Table.Cell>{this.getWarehouse(s)}</Table.Cell>
                                        <Table.Cell>{s.quantity}</Table.Cell>
                                        <Table.Cell>{s.order_line ? s.order_line.price : 0}</Table.Cell>
                                        <Table.Cell>{s.shipment ? s.shipment.status : ""}</Table.Cell>
                                    </Table.Row>
                                );
                            })
                        })}
                    </Table.Body>
                </Table>
                </div>
            </div>
        )
    }
}

MovementTable.propTypes = {
    data: PropTypes.array.isRequired,
    warehouses: PropTypes.array.isRequired
};

export default MovementTable


// WEBPACK FOOTER //
// ./src/components/reports/components/movement.js